import "../models/completion_page.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Collections ??= {};

AssessmentBuilder.Collections.CompletionPages = class CompletionPages extends Backbone.Collection {
  comparator(page) {
    return parseFloat(page.get("minScore"));
  }
};
AssessmentBuilder.Collections.CompletionPages.prototype.model = AssessmentBuilder.Models.CompletionPage;
